module.exports = "https://cdn.realtymogul.com/static/media/hero.d42d6c74.jpg";